<div class="wrapper text-center">
  <div class="text-wrapper">
    <!-- Editable Input Field -->
    @if (showText || text === '') {
      <input class="text-input" type="text" [(ngModel)]="text"
        [focusInput]="showText"
        (blur)="saveText()" (keyup.enter)="onEnter($event)"
        [maxlength]="maxInputLength">
    }

    <!-- Displayed Text (Double-Click to Edit) -->
    @if (!showText) {
      <div class="mask" (dblclick)="showText = true">
            <span class="text"  [ngClass]="{
                'default': textClass === 'default',
                'modified': textClass === 'modified'
            }">
          {{ text }}
          <i class="fa fa-pencil"></i>
        </span>
      </div>
    }
  </div>
</div>
